import React, { useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import { useNavigate } from "react-router-dom";

import destinationLogo from "../../../assets/images/CustomPinForLeafletMap/destination.png";
import bistatechOriginLogo from "../../../assets/images/CustomPinForLeafletMap/Bistatech-origin.png";
import originLogo from "../../../assets/images/CustomPinForLeafletMap/origin.png";
import "./Map.scss";

// snakBar for showing distance
import SnackBar from "../../GeneralComponents/SnackBar";

// start import for materialUI
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import axios from "axios";

// end import for materialUI

function LocationMarker() {
  // for routing
  const navigate = useNavigate();

  const [origin, setOrigin] = useState(null);
  const [destination, setDestination] = useState(null);
  const [originIsBistatech, setOriginIsBistatech] = useState(null);
  const [defaultCenter, setDefaultCenter] = useState({
    lat: 34.640552,
    lng: 50.874938,
  });
  const [distance, setDistance] = useState(null);

  const startPointIsBistatech = () => {
    setOriginIsBistatech({
      lat: 34.621262,
      lng: 50.864049,
    });
    setOpenOriginDialog(false);
  };

  // start materialUI
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const [openOriginDialog, setOpenOriginDialog] = useState(true);
  const [openDestinationDialog, setOpenDestinationDialog] = useState(true);

  // start get current location of user with GPS
  const getAndSetLocation = () => {
    if (navigator.geolocation) {
      try {
        navigator.geolocation.getCurrentPosition((position) => {
          setDestination({
            lat: position.coords.latitude.toString().slice(0, 9),
            lng: position.coords.longitude.toString().slice(0, 9),
          });
          calcDistance(
            position.coords.latitude.toString().slice(0, 9),
            position.coords.longitude.toString().slice(0, 9)
          );
          // calcDistance();
        });
      } catch {
        alert("مکان یابی ناموفق بود!");
      }
    }
    setOpenDestinationDialog(false);
  };
  // end get current location of user

  const handleCloseOriginDialog = () => {
    setOpenOriginDialog(false);
  };

  const handleCloseDestinationDialog = () => {
    setOpenDestinationDialog(false);
  };

  const calcDistance = (destinationLat, destinationLng) => {
    console.log(destination);
    // select which point is start point, Bistatech(core Office) Or other place
    const startOrigin = originIsBistatech === null ? origin : originIsBistatech;
    const urlGetDistanceBetweenTwoPoint = `https://api.neshan.org/v1/distance-matrix?origins=${startOrigin.lat},${startOrigin.lng}&destinations=${destinationLat},${destinationLng}`;
    const headerForGetDistance = {
      headers: {
        // api key from neshan account
        "api-key": "service.VcZ8HVYvDRZolBVdhGgjuToIgaFakB5jANh5UBwR",
        Accept: "application/json",
      },
    };
    axios
      .get(urlGetDistanceBetweenTwoPoint, headerForGetDistance)
      .then((res) => {
        const tempDistance = res.data.rows[0].elements[0].distance.text;
        // const timeDuration = res.data.rows[0].elements[0].duration.text
        setDistance(tempDistance);
      })
      .catch(() => {
        alert("در محاسبه فاصله مشکلی پیش آمده است");
      });
  };
  const map = useMapEvents({
    click(e) {
      // if origin not set yet,  set origin
      if (origin === null && originIsBistatech === null) {
        let location = e.latlng;
        setOrigin(location);
        // if destination not set yet, set destination
      } else if (destination === null) {
        let location = e.latlng;
        setDestination(location);
        calcDistance(location.lat, location.lng);
      }
      // map.flyTo(defaultCenter, map.getZoom())
      map.flyTo(defaultCenter, (map.zoom = [12]));
    },
  });
  const bistatechOriginIcon = L.icon({
    iconUrl: bistatechOriginLogo,
    iconSize: [29, 46],
    iconAnchor: [14, 46],
    // popupAnchor: null,
    // shadowUrl: null,
    // shadowSize: null,
    // shadowAnchor: null
  });
  const OriginIcon = L.icon({
    iconUrl: originLogo,
    iconSize: [30, 56],
    iconAnchor: [15, 56],
    // popupAnchor: null,
    // shadowUrl: null,
    // shadowSize: null,
    // shadowAnchor: null
  });
  const destinationIcon = L.icon({
    iconUrl: destinationLogo,
    iconSize: [29, 56],
    iconAnchor: [14, 56],
    // popupAnchor: null,
    // shadowUrl: null,
    // shadowSize: null,
    // shadowAnchor: null
  });

  const submitHandler = async () => {
    try {
      const startPoint = origin === null ? originIsBistatech : origin;

      const originLatTemp = await `${startPoint.lat}`;
      const originLatTempToStandardLength = await originLatTemp.slice(0, 9);

      const originLngTemp = await `${startPoint.lng}`;
      const originLngTempToStandardLength = await originLngTemp.slice(0, 9);

      const destinationLatTemp = await `${destination.lat}`;
      const destinationLatTempToStandardLength = await destinationLatTemp.slice(
        0,
        9
      );

      const destinationLngTemp = await `${destination.lng}`;
      const destinationLngTempToStandardLength = await destinationLngTemp.slice(
        0,
        9
      );

      const originTemp =
        await `${originLatTempToStandardLength},${originLngTempToStandardLength}`;
      const destinationTemp =
        await `${destinationLatTempToStandardLength},${destinationLngTempToStandardLength}`;

      await sessionStorage.setItem("origin", originTemp);
      await sessionStorage.setItem("destination", destinationTemp);
      await sessionStorage.setItem("distance", distance);
      navigate("/projects/signature");
    } catch {
      alert("در ذخیره سازی مقادیر مشکلی پیش آمده است");
    }
  };

  return (
    <>
      {originIsBistatech === null ? null : (
        <Marker position={originIsBistatech} icon={bistatechOriginIcon}>
          {/* if you delete destination so you can delete origin */}
          {destination === null && (
            <Popup>
              {/* reset origin and distance */}
              <button
                class="button-for-change-location"
                onClick={() => {
                  setOriginIsBistatech(null);
                  setDistance(null);
                }}
              >
                حذف مبدا
              </button>
            </Popup>
          )}
        </Marker>
      )}
      {origin === null ? null : (
        <Marker position={origin} icon={OriginIcon}>
          {/* if you delete destination so you can delete origin */}
          {destination === null && (
            <Popup>
              {/* reset origin and distance */}
              <button
                class="button-for-change-location"
                onClick={() => {
                  setOrigin(null);
                  setDistance(null);
                }}
              >
                حذف مبدا
              </button>
            </Popup>
          )}
        </Marker>
      )}
      {destination === null ? null : (
        <Marker position={destination} icon={destinationIcon}>
          <Popup>
            {/* reset destination and distance */}
            <button
              class="button-for-change-location"
              onClick={() => {
                setDestination(null);
                setDistance(null);
              }}
            >
              حذف مقصد
            </button>
          </Popup>
        </Marker>
      )}
      <Dialog
        open={openOriginDialog}
        // TransitionComponent={true}
        keepMounted
        onClose={handleCloseOriginDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"آیا مبدا شما دفتر بیستاتِک می باشد؟"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            اگر مبدا حرکت شما دفتر مرکزی شرکت می باشد، بله را انتخاب کنید تا به
            صورت خودکار به صورت مبدا برای شما تعیین گردد!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={startPointIsBistatech}>بله</Button>
          <Button onClick={handleCloseOriginDialog}>خیر</Button>
        </DialogActions>
      </Dialog>
      {/* start  dialog for get current location from GPS */}
      {origin || originIsBistatech ? (
        <Dialog
          open={openDestinationDialog}
          // TransitionComponent={true}
          keepMounted
          onClose={handleCloseDestinationDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"استفاده از GPS"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              آیا مقصد با استفاده از GPS ثبت گردد؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={getAndSetLocation}>بله</Button>
            <Button onClick={handleCloseDestinationDialog}>خیر</Button>
          </DialogActions>
        </Dialog>
      ) : null}
      {/* end of dialog for get current location from GPS */}
      <div className="submit-button-in-map-Component">
        {
          <Button
            disabled={!distance}
            variant="contained"
            color="success"
            onClick={() => submitHandler()}
          >
            {distance ? "تایید مبدا و مقصد" : "مبدا و مقصد را مشخص فرمایید"}
          </Button>
        }
      </div>

      {/* <button onClick={getAndSetLocation} style={{zIndex:"999",position:"absolute"}}>gpsssssssss</button> */}

      {/* show distance in snackBar */}
      {distance && <SnackBar message={distance} variant="success" />}
    </>
  );
}

function Map() {
  return (
    <div className="mainContainer">
      <MapContainer center={{ lat: 34.640552, lng: 50.874938 }} zoom={12}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker />
      </MapContainer>
    </div>
  );
}
export default Map;
